module.exports = __webpack_public_path__ + "static/media/user-red.9692245b.svg";